import React from "react";
import ConfigProvider from "./context/ConfigProvider";
import { AppRouter } from "./navigation/AppRouter";
import AuthProvider from "./context/AuthProvider";
import { ApolloAuthorizedProvider } from "./context/ApolloAuthorizedProvider";
import { AuthenticatedUserProvider } from "./context/AuthenticatedUserProvider";


export const AppProduction: React.FC = () => {

  return (
    <ConfigProvider>
      <AuthenticatedUserProvider>
        <ApolloAuthorizedProvider>
          <AuthProvider >
            <AppRouter />
          </AuthProvider>
        </ApolloAuthorizedProvider>
      </AuthenticatedUserProvider>
    </ConfigProvider>
  );
};